// Pricing migration 32 (ADO-3985), D-15: the deal's free product's name for the wide strips' "Free:
// {product}" segment (02, R1 05s, R4 + R5 05), read through the shared product detail store as the
// deal view names it (`useDealLines`). `null` while it is being read, when the deal names no free
// product, or when the catalogue cannot name it, so the strip never shows a made-up name.

import { useEffect } from 'react';
import type { MultibuyDeal } from '../api/multibuy-deals.client';
import { useProductDetailStore } from '../product-detail/useProductDetailStore';

/** Pass `null` where no wide strip shows, so nothing is read for it. */
export function useFreeProductName(deal: MultibuyDeal | null): string | null {
  const sku = deal?.freeProduct?.skuCode ?? null;
  useEffect(() => {
    if (sku !== null) void useProductDetailStore.getState().load(sku);
  }, [sku]);
  return useProductDetailStore((s) =>
    sku === null ? null : (s.bySku[sku]?.product?.name ?? null),
  );
}
